import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Button } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import styles from "./FavoritesList.module.scss.js";
const FavoritesList = memo(function FavoritesList2({
  onShowMore,
  isMorePages,
  renderPages,
  t
}) {
  return /* @__PURE__ */ jsx("div", { className: styles.favoritesList, children: /* @__PURE__ */ jsxs(Row, { justify: "center", children: [
    /* @__PURE__ */ jsx(Col, { span: 24, children: renderPages() }),
    isMorePages ? /* @__PURE__ */ jsx(Col, { span: 24, flex: "0 0 auto", className: styles.favoritesList__buttonCol, children: /* @__PURE__ */ jsx(Button, { type: "ghost", onClick: onShowMore, children: t("widgets.favoritesList.showMore") }) }) : null
  ] }) });
});
export {
  FavoritesList
};
